let allStores = [];
let map;
let markers = [];
let activeInfoWindow = null;

window.initStoreLocatorMap = function () {
  map = new google.maps.Map(document.getElementById("store-map"), {
    center: { lat: 52.1326, lng: 5.2913 },
    zoom: 7
  });

  loadStores();
};

function loadStores() {
  fetch(window.STORE_LOCATOR_CONFIG.storesUrl)
    .then(response => response.json())
    .then(stores => {
      allStores = stores.filter(store => store.lat && store.lng);

      renderStores(allStores);
      renderMarkers(allStores);
      fitMapToStores(allStores);
    })
    .catch(error => {
      console.error("Store JSON loading error:", error);
    });
}

function renderStores(stores) {
  const list = document.getElementById("store-list");
  const count = document.getElementById("store-count");

  count.innerText = `${stores.length} winkels gevonden`;
  list.innerHTML = "";

  stores.forEach(store => {
    const item = document.createElement("div");
    item.className = "store-card";

    item.innerHTML = `
      <h3>${store.name || ""}</h3>
      <p>${store.address || ""}</p>
      <p>${store.zip || ""} ${store.city || ""}</p>
      ${store.distance ? `<p class="store-distance">${store.distance.toFixed(1)} km away</p>` : ""}
      ${store.hours ? `<button type="button" class="hours-btn">Zie openingstijden</button><div class="hours">${store.hours}</div>` : ""}
      ${store.phone ? `<p>Phone: ${store.phone}</p>` : ""}
      ${store.email ? `<p>Email: ${store.email}</p>` : ""}
      ${store.url ? `<a href="${store.url}" target="_blank" rel="noopener">Website</a>` : ""}
    `;

    item.addEventListener("click", function () {
      document.querySelectorAll(".store-card").forEach(card => {
        card.classList.remove("active");
      });

      item.classList.add("active");
      focusStore(store);
    });

    const hoursButton = item.querySelector(".hours-btn");
    const hoursBox = item.querySelector(".hours");

    if (hoursButton && hoursBox) {
      hoursButton.addEventListener("click", function (e) {
        e.stopPropagation();
        hoursBox.classList.toggle("is-open");
      });
    }

    list.appendChild(item);
  });
}

function renderMarkers(stores) {
  markers.forEach(marker => marker.setMap(null));
  markers = [];

  stores.forEach(store => {
    if (!store.lat || !store.lng) return;

  const marker = new google.maps.Marker({
  position: {
    lat: Number(store.lat),
    lng: Number(store.lng)
  },

  map: map,

  title: store.name || "",

  icon: {
    path: google.maps.SymbolPath.CIRCLE,
    fillColor: "#0b5d3b",
    fillOpacity: 1,
    strokeColor: "#ffffff",
    strokeWeight: 2,
    scale: 10
  }
});

    marker.addListener("click", function () {
      focusStore(store);
    });

    markers.push(marker);
  });
}

function focusStore(store) {
  if (!store.lat || !store.lng) return;

  const position = {
    lat: Number(store.lat),
    lng: Number(store.lng)
  };

  map.setCenter(position);
  map.setZoom(14);

  if (activeInfoWindow) {
    activeInfoWindow.close();
  }

  activeInfoWindow = new google.maps.InfoWindow({
    content: `
      <div class="store-info-window">
        <strong>${store.name || ""}</strong><br>
        ${store.address || ""}<br>
        ${store.zip || ""} ${store.city || ""}
      </div>
    `
  });

  const marker = markers.find(m => {
    const markerPosition = m.getPosition();
    return (
      markerPosition.lat() === Number(store.lat) &&
      markerPosition.lng() === Number(store.lng)
    );
  });

  if (marker) {
    activeInfoWindow.open(map, marker);
  }
}

function fitMapToStores(stores) {
  const bounds = new google.maps.LatLngBounds();
  let hasStores = false;

  stores.forEach(store => {
    if (!store.lat || !store.lng) return;

    bounds.extend({
      lat: Number(store.lat),
      lng: Number(store.lng)
    });

    hasStores = true;
  });

  if (hasStores) {
    map.fitBounds(bounds);
  }
}

document.addEventListener("input", function (e) {
  if (e.target.id !== "store-search") return;

  const query = e.target.value.toLowerCase().trim();

  if (!query) {
    renderStores(allStores);
    renderMarkers(allStores);
    fitMapToStores(allStores);
    return;
  }

  const filtered = allStores.filter(store => {
    return (
      String(store.name || "").toLowerCase().includes(query) ||
      String(store.city || "").toLowerCase().includes(query) ||
      String(store.zip || "").toLowerCase().includes(query) ||
      String(store.address || "").toLowerCase().includes(query) ||
      String(store.country || "").toLowerCase().includes(query) ||
      String(store.category || "").toLowerCase().includes(query)
    );
  });

  renderStores(filtered);
  renderMarkers(filtered);
  fitMapToStores(filtered);
});

document.addEventListener("click", function (e) {
  if (e.target.id !== "use-location") return;

  if (!navigator.geolocation) {
    alert("Geolocation is not supported by your browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    position => {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      const nearby = allStores
        .map(store => {
          return {
            ...store,
            distance: getDistanceKm(
              userLat,
              userLng,
              Number(store.lat),
              Number(store.lng)
            )
          };
        })
        .filter(store => store.distance <= window.STORE_LOCATOR_CONFIG.radiusKm)
        .sort((a, b) => a.distance - b.distance);

      renderStores(nearby);
      renderMarkers(nearby);
      fitMapToStores(nearby);

      new google.maps.Marker({
        position: { lat: userLat, lng: userLng },
        map: map,
        title: "Your location"
      });
    },
    error => {
      console.error("Geolocation error:", error);
      alert("Unable to get your location.");
    }
  );
});

function getDistanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) *
    Math.sin(dLng / 2);

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}